import { createFileRoute } from '@tanstack/react-router';

import { getAppIds } from 'hooks/useAppIds';
import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';
import { preloadSourceApps } from 'hooks/useQuery/useQuerySourceApps';

import { RetainView } from 'views/RetainView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/retain/')({
  component: RetainView,
  staticData: {
    title: 'Sell',
    back: {
      to: '/home/',
    },
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    const apps = await preloadSourceApps(queryClient);

    void preloadProgressData(queryClient, getAppIds(apps));
  },
});
